exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=text][data-v-0d8dd190]{font-size:16px}.task-title.field-value[data-v-0d8dd190]{padding-top:21px;padding-left:20px}input[type=text].form-control.title-field[data-v-0d8dd190]{font-size:16px}", ""]);

// exports
